import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_edi_set_wavelength_connector_transmissionService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { shipment_id?: number, integration_id: string, transaction_id: string, transaction_type?: string, file_content: string }): Promise<{ messages?: any[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.integration_id)) {
      $missingRequiredInParams.push('\'integration_id\'');
    }
    if (isNil($inParams.transaction_id)) {
      $missingRequiredInParams.push('\'transaction_id\'');
    }
    if (isNil($inParams.file_content)) {
      $missingRequiredInParams.push('\'file_content\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

